var map = {
	"./API-icon.png": 4097,
	"./Bootstrap-icon.svg": 2438,
	"./CSS-icon.svg": 276,
	"./D3js-icon.svg": 2005,
	"./Express-icon.svg": 1406,
	"./HTML-icon.svg": 1937,
	"./Javascript-icon.svg": 3057,
	"./MongoDB-icon.svg": 8781,
	"./Mongoose-icon.png": 1325,
	"./Nodejs-icon.svg": 2836,
	"./React-icon.svg": 8793,
	"./SASS-icon.svg": 5512,
	"./graphQL-icon.png": 6804,
	"./postgresql-icon.svg": 1246,
	"./typescript-icon.svg": 2688
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5481;